import { Component, Inject, Input, NgZone, OnInit } from '@angular/core';
import { Observable, merge, fromEvent } from 'rxjs';

import { AuthUser } from '../../core/auth/auth-frame/auth-user.model';
import { AuthService } from '../../core/auth/auth.service';
import { MenuSubMenu } from '../../shared/menu/menu-sub-menu.model';
import { Router } from '@angular/router';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { FeatureToggleService } from '@app/shared/feature-toggle/feature.toggle.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { detailFromBreadcrumb, normalizePath } from '@app/shared/utils';
import { normalizePathFromBreadcrumb } from '../../shared/utils';

@Component({
  selector: "app-full-menu-sub-option",
  templateUrl: "./full-menu-sub-option.component.html",
  styleUrls: ["./full-menu-sub-option.component.css"],
})
export class FullMenuSubOptionComponent implements OnInit {
  @Input() subOptionList: Array<MenuSubMenu>;
  @Input() nameSubOption;

  @Input() initialTabIndex: number;
  @Input() menuTranslationKey: string;

  public authUser: AuthUser;
  authSubject: Observable<AuthUser>;

  constructor(
    private authService: AuthService,
    @Inject("Window") private _window: Window,
    private router: Router,
    private itauUserIdleService: ItauUserIdleService,
    private sessionService: SessionService,
    private ngZone: NgZone,
    private featureToggleService: FeatureToggleService,
    private _sdkAnalyticsService: SdkAnalyticsService) { }

  ngOnInit() {
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {
      this.authUser = user;
    });
  }

  getMenuURL(menuURL: string): string {
    if (menuURL == undefined || menuURL == "") return "#";

    return menuURL;
  }

  openModal(codFunction, name, typeMenu, url, path?) {

    if (path && this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: detailFromBreadcrumb(path)
      });
    }

    if (/IS\/#/.test(url)) {
      this.router.navigate([`${url.split('/#')[1]}`]);
      return false;
    }

    if (typeMenu != 5) {
      var sUrl = this.authUser.serverEstatisticas + "?xyz=0";

      try {
        this.itauUserIdleService.stopWatching();
        this.sessionService.updateSession().subscribe(() => { });
        let userType = this.authUser.tipo == 1 ? "A" : "C";
        sUrl += this.getQueryString(
          this.authUser.token,
          this.authUser.idSessao,
          this.authUser.idConexao,
          this.authUser.gestor,
          this.authUser.name,
          userType
        );
        sUrl += this.getQueryStringFunction(codFunction);
        var windowOK4 = this._window.open(
          sUrl,
          name,
          "directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5"
        );
        this._sdkAnalyticsService.trackEvent('screen_view', {
          custom_path: normalizePathFromBreadcrumb(path, { prefix: '/iss/lg/' }),
          implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
          detail: detailFromBreadcrumb(path)
        });

        this.itauUserIdleService.setCustomActivityEvents(
          merge(
            fromEvent(window, "mousemove"),
            fromEvent(window, "resize"),
            fromEvent(document, "keydown"),
            fromEvent(document, "touchstart"),
            fromEvent(document, "touchend"),
            fromEvent(windowOK4, "mousemove"),
            fromEvent(windowOK4, "resize")
          )
        );
        this.itauUserIdleService.startWatching();
      } catch (ex) {
        throw ex;
      }
    } else {
      this.openModalContext(url);
    }
  }

  openModalContext(route): void {
    this.setTimeoutNavigation(route, 3);
  }

  setTimeoutNavigation(route: string, retries: number): void {
    let attempts = 0;
    const intervalId = setInterval(() => {
      this.router.navigate([route]).then(success => {
        if (success) {
          clearInterval(intervalId);
        } else {
          attempts++;
          if (attempts >= retries) {
            clearInterval(intervalId);
          }
        }
      }).catch(error => {
        attempts++;
        if (attempts >= retries) {
          console.log(error);
          clearInterval(intervalId);
        }
      });
    }, 500);
  }

  private getQueryStringFunction(codFunction) {
    try {
      return "&iDFuncao=" + -1 * codFunction;
    } catch (ex) {
      throw ex;
    }
  }

  private getQueryString(
    token,
    idConnection,
    idSession,
    sGestor,
    nameUser,
    userType
  ) {
    try {
      return (
        "&sessao=" +
        token +
        "&id=" +
        idConnection +
        "&idsessao=" +
        idSession +
        "&gestor=" +
        sGestor +
        "&nomeUsu=" +
        nameUser +
        "&tipousu=" +
        userType
      );
    } catch (ex) {
      throw ex;
    }
  }

  goToiServices(url?: string) {
    if (this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: 'menu-iservices'
      });
    }

    this.featureToggleService.goToiServices(url);
  }

  submitEvent(namePage: string) {
  }
}
